import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Eighteenththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Deep Ocean */
            --primary: #0f172a;       /* Navy */
            --secondary: #0ea5e9;     /* Sky */
            --bg: #f8fafc;
            --font-stack: 'Inter', sans-serif;
        }

        body { font-family: var(--font-stack); background: var(--bg); color: var(--primary); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; }
        .brand { font-size: 1.5rem; font-weight: 700; letter-spacing: -0.5px; }
        .nav a { margin-left: 20px; color: #64748b; text-decoration: none; font-weight: 500; }
        .nav a:hover { color: var(--primary); }
        
        .hero { background: var(--primary); color: white; padding: 100px 0; border-radius: 20px; margin-top: 20px; display: flex; align-items: center; }
        .hero h1 { font-size: 3rem; margin-bottom: 20px; }
        .btn { background: var(--secondary); color: white; padding: 12px 24px; border-radius: 8px; border: none; font-weight: 600; cursor: pointer; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 40px; margin-top: 60px; }
        .card { background: white; border-radius: 12px; padding: 25px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); border: 1px solid #e2e8f0; }
        
        .section-title { font-size: 2rem; border-left: 5px solid var(--secondary); padding-left: 20px; margin: 80px 0 40px; }
        
        .footer { border-top: 1px solid #e2e8f0; margin-top: 100px; padding: 50px 0; color: #64748b; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="navbar">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                    </div>
                </nav>
                
                <header className="hero">
                    <div style={{padding: '0 60px', width: '100%'}}>
                         <h1>Dive into Quality.</h1>
                         <p style={{fontSize: '1.2rem', color: '#cbd5e1', marginBottom: '30px', maxWidth: '500px'}}>Professional services tailored to your depth of needs.</p>
                         <button className="btn">Explore Services</button>
                    </div>
                </header>
                
                <h2 className="section-title" id="services">Our Services</h2>
                <div className="grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                             <div style={{width: '50px', height: '50px', background: '#e0f2fe', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px'}}>
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '30px', height: '30px'}} alt=""/> : <span>🌊</span>}
                             </div>
                             <h3>{item.name}</h3>
                             <p style={{fontSize: '0.9rem', color: '#64748b', margin: '10px 0 20px'}}>{item.description}</p>
                             <a href={`tel:${get_data.mobile}`} style={{color: 'var(--secondary)', fontWeight: 600, textDecoration: 'none'}}>Contact Us &rarr;</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>

                <h2 className="section-title" id="products">Products</h2>
                <div className="grid">
                    {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{padding: 0, overflow: 'hidden'}}>
                             <div style={{height: '200px'}}>
                                 {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555', width: '100%', height: '100%', objectFit: 'cover' }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                             </div>
                             <div style={{padding: '20px'}}>
                                 <h3>{item.service_name}</h3>
                                 <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px'}}>
                                     {item.price && <span style={{fontWeight: 700}}>₹{item.price}</span>}
                                     <button onClick={() => addToCart(item)} className="btn" style={{padding: '8px 16px', fontSize: '0.8rem'}}>Add</button>
                                 </div>
                             </div>
                        </div>
                    ))}
                </div>
                
                <h2 className="section-title" id="categories">Browse Categories</h2>
                <div className="grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                             <div style={{width: '50px', height: '50px', background: '#e0f2fe', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px'}}>
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '30px', height: '30px'}} alt=""/> : <span>🌊</span>}
                             </div>
                             <h3>{item.name}</h3>
                             <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                                 <a href={`tel:${get_data.mobile}`} style={{color: 'var(--secondary)', fontWeight: 600, textDecoration: 'none', border: '1px solid var(--secondary)', padding: '5px 10px', borderRadius: '4px'}}>Call</a>
                                 <a href="#contact" style={{background: 'var(--secondary)', color: 'white', fontWeight: 600, textDecoration: 'none', padding: '5px 10px', borderRadius: '4px'}}>Enquiry</a>
                             </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>

                <footer className="footer" id="contact">
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px'}}>
                        <div>
                            <h3 style={{color: 'var(--primary)'}}>{get_data.service_name}</h3>
                            <p>{get_data.business_location_name}</p>
                            <p>{get_data.email}</p>
                        </div>
                        <div style={{textAlign: 'right'}}>
                            <p>&copy; {new Date().getFullYear()}. Built with precision.</p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default Eighteenththeme;
